<script lang="ts">
	import Read from "../common/Read.svelte";
	import backgroundURL from "../../../common/assets/wood.webp";
	import { _ } from "svelte-i18n";

	let { params = { id: "" } }: { params: { id: string } } = $props();
</script>

<div class="page-wrapper story" style={`background-image:url('${backgroundURL}')`}>
	<h1 class="heading">{$_("story.childBookTitle")}</h1>
	<Read id={params.id} baseStoryUrlPath="story" />
</div>

<style>
	@font-face {
		font-family: StoryMainFont;
		src: url("../../../common/assets/sour-gummy.ttf");
	}

	:global(.story .text) {
		font-family: StoryMainFont, sans-serif;
	}

	:global(.story .heading) {
		font-family: StoryMainFont, sans-serif;
	}

	.page-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		height: 100svh;
		width: 100svw;
		position: fixed;
		top: 0;
		left: 0;
	}

	.heading {
		margin: 1rem;
		font-size: 3vw;
		color: #ffff00;
	}
</style>
